import PenguinSpriteFactory from './PenguinSpriteFactory'


export default class PenguinLoader {

    constructor(world) {
        this.world = world

        const baseNameStyle = {
            fontFamily: 'Arial',
            fontSize: 24,
            align: 'center',
            fixedWidth: 250
        }

        this.nameStyles = {
            default: {
                ...baseNameStyle,
                color: '#000000'
            },
            client: {
                ...baseNameStyle,
                color: '#FFFFFF',
                stroke: '#000000',
                strokeThickness: 6
            },
            npc: {
                ...baseNameStyle,
                color: '#FFFFFF', // White text
                stroke: '#0066FF', // Blue stroke (Club Penguin NPC style)
                strokeThickness: 6
            }
        }
    }

    loadPenguin(penguin) {
        this.addPenguin(penguin)
        this.addShadow(penguin)
        this.addInput(penguin)

        penguin.playFrame(penguin.frame)
    }

    addPenguin(penguin) {
        penguin.bodySprite = PenguinSpriteFactory.create(penguin, 'body', 1)
        penguin.penguinSprite = PenguinSpriteFactory.create(penguin, 'penguin', 2)
    }

    addShadow(penguin) {
        let shadow = penguin.room.add.image(0, 0, 'penguin_base', 'shadow')

        penguin.addAt(shadow, 0)
    }

    addRing(penguin) {
        let ring = penguin.room.add.image(0, 0, 'penguin_base', 'ring')

        penguin.addAt(ring, 0)
    }

    addName(penguin) {
        let x = penguin.x
        let y = penguin.y + 40
        const clientId = this.world?.client?.id
        const isClientPenguin = (clientId)
            ? penguin.id === clientId
            : Boolean(penguin.isClient)

        // Normalise flag so downstream logic can trust it
        penguin.isClient = isClientPenguin

        // Use mascot name if available, otherwise use displayName or username
        let displayName = penguin.username
        if (penguin.mascot && penguin.mascot.name) {
            displayName = penguin.mascot.name
        } else if (penguin.displayName) {
            displayName = penguin.displayName
        }

        if (penguin.isNPC && !displayName) {
            displayName = 'NPC'
        }

        let style = this.nameStyles.default
        
        if (isClientPenguin) {
            style = this.nameStyles.client
        } else if (penguin.isNPC) {
            style = this.nameStyles.npc
        }

        let nameTag = penguin.room.add.text(x, y, displayName, style)
        nameTag.isNameTag = true

        nameTag.setOrigin(0.5)
        nameTag.depth = penguin.depth + 2000 // Keep nametag above everything else

        return nameTag
    }

    addInput(penguin) {
        let hitArea = new Phaser.Geom.Ellipse(0, -20, 70, 90)

        penguin.setInteractive({
            cursor: 'pointer',
            hitArea: hitArea,
            hitAreaCallback: Phaser.Geom.Ellipse.Contains
        })

        // Use mascot name if available, otherwise use displayName or username
        let displayName = penguin.username
        if (penguin.mascot && penguin.mascot.name) {
            displayName = penguin.mascot.name
        } else if (penguin.displayName) {
            displayName = penguin.displayName
        }

        penguin.on('pointerup', () => this.onPenguinClick(penguin, displayName))
    }

    onPenguinClick(penguin, username) {
        // Check if this is an NPC - use custom click handler
        if (penguin.isNPC && typeof penguin.onClick === 'function') {
            penguin.onClick()
            return
        }
        
        // Regular penguin - show player card
        this.world.interface.showCard(penguin.id, username)
    }

}
